import { ChecklistPolozka } from '../../../api/JsdhNotifikaceService/generated/models/HydrantBod';

// FE fallback, pokud BE endpoint /checklist není dostupný. Primárně se používá BE konstanta
// (useChecklistQuery), tato slouží jako default a pro offline render.
// Položky odpovídají: ČSN 73 0873 Příloha C, vyhl. 246/2001 Sb. §7,
// ČSN EN 14339/14384, značení ČSN 75 5025
// (grounded from public sources; final wording per the norm).
export const HYDRANT_CHECKLIST: ChecklistPolozka[] = [
  { kod: 'pristupnost', nazev: 'Přístupnost hydrantu (volný přístup a manipulační prostor)', mereny: false },
  { kod: 'znaceni', nazev: 'Orientační tabulka / značení (umístění, čitelnost)', mereny: false },
  { kod: 'poklop_kryt', nazev: 'Poklop/šachta (podzemní) resp. kryt (nadzemní) – stav a otevíratelnost', mereny: false },
  { kod: 'uzaver_vreteno', nazev: 'Funkčnost uzávěru / vřetena (otevírání a zavírání)', mereny: false },
  { kod: 'odvodneni', nazev: 'Funkčnost odvodnění po uzavření', mereny: false },
  { kod: 'tesnost', nazev: 'Těsnost v uzavřeném stavu (bez úniku)', mereny: false },
  { kod: 'stav', nazev: 'Celkový stav (koroze, mechanické poškození)', mereny: false },
];
